import './WebVitalChart.less';
import React from 'react';

type Props = {
    maxGoodVal: number;
    minPoorVal: number;
    markerAt: number;
    unitsSuffix?: string;
};

export default function WebVitalChart({ markerAt, maxGoodVal, minPoorVal, unitsSuffix }: Props) {
    const scaleMax = maxGoodVal + minPoorVal;
    let showMarkerAt: number = markerAt;

    if (showMarkerAt < maxGoodVal / 4) {
        showMarkerAt = maxGoodVal / 4;
    }

    if (showMarkerAt > scaleMax - (scaleMax - minPoorVal) / 4) {
        showMarkerAt = scaleMax - (scaleMax - minPoorVal) / 4;
    }

    let scaleFactor = 100 / scaleMax;

    let goodValStyles = {
        width: `${maxGoodVal * scaleFactor}%`,
    };

    let needsImprovementValStyles = {
        left: goodValStyles.width,
        width: `${(minPoorVal - maxGoodVal) * scaleFactor}%`,
    };

    let poorValStyles = {
        left: `${minPoorVal * scaleFactor}%`,
        width: `${(scaleMax - minPoorVal) * scaleFactor}%`,
    };

    let markerLeft = `${showMarkerAt * scaleFactor}%`;
    const maxGoodValTickLeft = `${maxGoodVal * scaleFactor}%`;
    const minPoorValTickLeft = `${minPoorVal * scaleFactor}%`;

    return (
        <div className="web-vital-chart-container">
            <div className="web-vital-chart">
                <div
                    className="good"
                    style={goodValStyles}
                ></div>
                <div
                    className="needs-improvement"
                    style={needsImprovementValStyles}
                ></div>
                <div
                    className="poor"
                    style={poorValStyles}
                ></div>
                <div
                    className="marker"
                    style={{ left: markerLeft }}
                ></div>
                <p
                    className="marker-value"
                    style={{ left: markerLeft }}
                >
                    {markerAt}
                    {unitsSuffix || ''}
                </p>
                <div className="ticks">
                    <div
                        className="tick"
                        style={{ left: maxGoodValTickLeft }}
                    ></div>
                    <div
                        className="tick"
                        style={{ left: minPoorValTickLeft }}
                    ></div>
                    <p
                        className="tick-value"
                        style={{ left: maxGoodValTickLeft }}
                    >
                        {maxGoodVal}
                        {unitsSuffix || ''}
                    </p>
                    <p
                        className="tick-value"
                        style={{ left: minPoorValTickLeft }}
                    >
                        {minPoorVal}
                        {unitsSuffix || ''}
                    </p>
                </div>
            </div>
        </div>
    );
}
